import { render } from "./CartProductsList.vue?vue&type=template&id=2e3ff10c"
import script from "./CartProductsList.vue?vue&type=script&lang=js"
export * from "./CartProductsList.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__